module.exports = __webpack_public_path__ + "static/media/nv-caramel.8dd7b4b5.jpg";